export const NUTSHELL_PRO_MONTHLY = 'ns-uub-m';
export const NUTSHELL_PRO_ANNUAL = 'ns-uub-a';

export const NUTSHELL_BUSINESS_MONTHLY = 'ns-uuf-m';
export const NUTSHELL_BUSINESS_ANNUAL = 'ns-uuf-a';

export const ENGAGEMENT_FOUNDATION_MONTHLY = 'ne-uua-m'; // not a real SKU for foundation
export const ENGAGEMENT_PRO_MONTHLY = 'ne-uub-m';

export const MARKETING_FOUNDATION_MONTHLY = 'nk-uua-m'; // not a real SKU for foundation
export const MARKETING_PRO_MONTHLY = 'nk-uub-m';

export const ADD_ONS_HASH = '#add-ons';
export const MARKETING_HASH = '#campaigns';
export const REVENUE_BOOSTER_HASH = '#revenue-booster';
export const NUTSHELL_IQ_HASH = '#nutshell-iq';
export const INBOX_HASH = '#sms';
export const SMS_CAMPAIGNS_HASH = '#sms-credits';
export const QUOTES_HASH = '#quotes';
export const ADD_ONS_HASHES = [
    ADD_ONS_HASH,
    REVENUE_BOOSTER_HASH,
    NUTSHELL_IQ_HASH,
    INBOX_HASH,
    SMS_CAMPAIGNS_HASH,
    QUOTES_HASH,
];
